import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const SharesListHeader = ({
  profile,
  scope,
  orderBy,
  order,
  handleChangeOrder,
}) => {
  const changeOrder = (e, field, newOrder) => {
    e.preventDefault();
    handleChangeOrder(field, newOrder);
  };

  const intl = useIntl();

  return (
    <tr>
      <th className="share-thumbnail">
        {' '}
      </th>
      <th className="share-link">
        {intl.formatMessage({ defaultMessage: 'Link' })}
      </th>
      <th className="share-branding">
        {intl.formatMessage({ defaultMessage: 'Branding' })}
      </th>
      {(profile.is_admin || scope === 'to_user') && (
        <th className="share-user-name">
          {intl.formatMessage({ defaultMessage: 'Created by' })}
        </th>
      )}
      <th className={`th-sortable${orderBy === 'created_at' ? ' active' : ''}`}>
        <a href="#sort" onClick={(e) => { changeOrder(e, 'created_at', order === 'asc' ? 'desc' : 'asc'); }}>
          {intl.formatMessage({ defaultMessage: 'Created' })}
          {' '}
          {orderBy === 'created_at' && (
            <i className={`fas fa-long-arrow-${order === 'asc' ? 'down' : 'up'}`} />
          )}
        </a>
      </th>
      <th className="share-collection">
        {intl.formatMessage({ defaultMessage: 'Collection' })}
      </th>
      <th className="share-files">
        {intl.formatMessage({ defaultMessage: 'Files' })}
      </th>
      {(profile.is_admin || scope === 'by_user') && (
        <th className="share-links">
          {intl.formatMessage({ defaultMessage: 'Views' })}
        </th>
      )}
      <th className="share-attributes">
        {' '}
      </th>
      <th>
        {' '}
      </th>
    </tr>
  );
};

SharesListHeader.propTypes = {
  profile: PropTypes.object.isRequired,
  scope: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  order: PropTypes.string.isRequired,
  handleChangeOrder: PropTypes.func.isRequired,
};

export default SharesListHeader;
